import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18next from './i18n'

import VueI18Next from '@panter/vue-i18next'

Vue.config.productionTip = false

Vue.use(VueI18Next)

const i18n = new VueI18Next(i18next)

// TODO: For future reference, we could use
// this hook to use Sentry for Vue.
// Vue.config.errorHandler =

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
